import { ReactNode } from 'react';
import { ButtonGroup, Tooltip } from '@mui/material';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import { TRANSPARENT_COLOR } from '@/constants';
import { OutlinedIconButton } from './styles';
import { CuboidBase, CuboidState } from '../../types';
import { useShrinkCurrentCuboid } from '../../hooks/useShrinkCurrentCuboid';
import { useResetCurrentCuboidRotation } from '../../hooks/useResetCurrentCuboidRotation';

const AdjustButton = ({
  title,
  icon,
  onClick,
}: {
  title: string;
  icon: ReactNode;
  onClick: () => void;
}) => {
  return (
    <Tooltip title={title}>
      <OutlinedIconButton sx={{ background: TRANSPARENT_COLOR }} onClick={onClick}>
        {icon}
      </OutlinedIconButton>
    </Tooltip>
  );
};

type CuboidAdjustButtonGroupProps<CuboidT extends CuboidBase> = {
  cuboidState: CuboidState<CuboidT>;
};

export const CuboidAdjustButtonGroup = <CuboidT extends CuboidBase>({
  cuboidState,
}: CuboidAdjustButtonGroupProps<CuboidT>) => {
  const shrinkCurrentCuboid = useShrinkCurrentCuboid(cuboidState);

  const resetCurrentCuboidRotation = useResetCurrentCuboidRotation(cuboidState);

  return (
    <>
      <ButtonGroup sx={{ paddingBottom: '10px' }}>
        <AdjustButton
          title="Shrink"
          onClick={shrinkCurrentCuboid}
          icon={
            <SettingsEthernetIcon
              style={{
                color: '#fff',
              }}
            />
          }
        />
        <AdjustButton
          title="Reset Rotation"
          onClick={resetCurrentCuboidRotation}
          icon={
            <SyncLockIcon
              style={{
                color: '#fff',
              }}
            />
          }
        />
      </ButtonGroup>
    </>
  );
};
